export default "__VITE_ASSET__laMRfPqx__"